module.exports = __webpack_public_path__ + "static/media/PM103.be3888b6.png";